export default __webpack_public_path__ + "static/cro-logo-0ece98756f2fa087e3067acfc5baee56.png";